export const blockIconsSocialGroupAddNew = (
	<span className='material-symbols-outlined'>group_add</span>
);
